import {
  changeClosingFilterEndBusinessDate,
  changeClosingFilterStartBusinessDate,
  reportClosingFilterEndBusinessDateSelector,
  reportClosingFilterStartBusinessDateSelector,
} from '../../../state';
import { DateRangeFlexSalesProps } from '../../DateRangeFlexSales';
import ReportBusinessDateRangeFilter from '../../ReportFilters/filters/BusinessDateRangeFilter';

type BusinessDateRangeFilterProps = Pick<
  DateRangeFlexSalesProps<Date>,
  'spacing' | 'requiredIncomplete'
>;

const BusinessRangeFilter = (props: BusinessDateRangeFilterProps) => (
  <ReportBusinessDateRangeFilter
    {...props}
    maxDate={new Date()}
    startDateSelector={reportClosingFilterStartBusinessDateSelector}
    endDateSelector={reportClosingFilterEndBusinessDateSelector}
    changeStartDateAction={changeClosingFilterStartBusinessDate}
    changeEndDateAction={changeClosingFilterEndBusinessDate}
  />
);

export default BusinessRangeFilter;
